/**
 * TODO: Fix MobileMedia call on every file import.
 *
 * const MobileMedia = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT}px)`);
 * export { MobileMedia };
 *
 * This is executed on every import of the file. While the app works, this makes
 * testing a pain in the ass.
 *
 * Update utility/windowMatchMedia.js if possible after this is done.
 * */

import React from 'react';
import Responsive from 'react-responsive';
import breakpoints from 'legacy-styles/utility/Breakpoints.module.scss';
import { mapValues } from 'lodash';

const { mobile, small, smallplus, medium, large } = mapValues(
  breakpoints,
  Number,
);
const DUMMY_MAX_WIDTH = 9999;
const MOBILE_BREAKPOINT = mobile;

/**
 * Draws responsive view based on the screens
 * @param {array} screens List of condition strings
 * */
const ResponsiveView = React.forwardRef((props, ref) => {
  const { screens, children, ...otherProps } = props;

  const resolutions = {
    mobile: {
      minWidth: 0,
      maxWidth: medium - 1,
    },
    desktop: {
      minWidth: medium,
      maxWidth: DUMMY_MAX_WIDTH,
    },
    'x-small': {
      minWidth: 0,
      maxWidth: small - 1,
    },
    small: {
      minWidth: small,
      maxWidth: smallplus - 1,
    },
    smallplus: {
      minWidth: smallplus,
      maxWidth: medium - 1,
    },
    medium: {
      minWidth: medium,
      maxWidth: large - 1,
    },
    large: {
      minWidth: large,
      maxWidth: DUMMY_MAX_WIDTH,
    },
  };

  const queryRes = Object.keys(resolutions).reduce(
    (screenSizes, currentResolutionKey) => {
      if (screens.includes(currentResolutionKey)) {
        const currentResolution = resolutions[currentResolutionKey];

        return {
          minWidth: Math.min(screenSizes.minWidth, currentResolution.minWidth),
          maxWidth: Math.max(screenSizes.maxWidth, currentResolution.maxWidth),
        };
      }

      return screenSizes;
    },
    { minWidth: DUMMY_MAX_WIDTH, maxWidth: 0 },
  );

  const { minWidth, maxWidth } = queryRes;
  const maxSize = maxWidth === DUMMY_MAX_WIDTH ? null : maxWidth;

  let query = `(min-width: ${minWidth}px)`;
  if (maxSize) {
    query = `(min-width: ${minWidth}px) and (max-width: ${maxWidth}px)`;
  }

  return (
    <Responsive query={query}>
      {(matches) => {
        if (matches) {
          return React.Children.toArray(children).map((child, index) =>
            React.cloneElement(child, {
              ...otherProps,
              key: `responsive-view-${index}`,
              ref,
            }),
          );
        }

        return null;
      }}
    </Responsive>
  );
});

const MobileMedia = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT}px)`);
const TabletMedia = window.matchMedia(`(max-width: ${medium}px)`);
export { MobileMedia, TabletMedia };

export default ResponsiveView;
